import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class SpecificProcessService {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getSpecificProcess() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/specificProcesses');
    }

    addSpecificProcess(specificProcess: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/addspecificProcess', specificProcess);
    }

    updateSpecificProcess(specificProcess: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/updatespecificProcess', specificProcess);
    }
}